import React, { useEffect } from 'react';

import { Controller } from 'react-hook-form';

import classes from 'components/common/GlobalFiltersInPage/Filters.module.scss';
import { FiltersStatus } from 'components/common/GlobalFiltersInPage/GlobalFiltersInPage';
import { OptionValue } from 'components/common/GlobalFiltersInPage/components/WbsFilter/wbsFilter';
import { FilterLabels } from 'components/common/GlobalFiltersInPage/globalFiltersInPage.utils';
import { signalSingleFilterIsReady } from 'components/common/GlobalFiltersInPage/hooks/useSubscribersFiltersReady';

import { Select } from 'components/DesignSystem/Select';

interface Props {
    methods?: any;
    name: string;
    filtersStatusRef?: React.MutableRefObject<FiltersStatus>;
    handleFilters?: () => void;
    value?: string;
    isSelected?: boolean;
}

const options: ISelectOption<string>[] = [
    {
        label: 'No',
        value: '0',
    },
    {
        label: 'Yes',
        value: '1',
    },
];

export const TrackedActivity = ({
    name,
    methods,
    filtersStatusRef,
    handleFilters,
    value,
    isSelected = true,
}: Props) => {
    useEffect(() => {
        if (!filtersStatusRef?.current || filtersStatusRef?.current[name]?.isReady) {
            return;
        }

        signalSingleFilterIsReady({ filterId: name, isReady: true });
    }, [value, name, filtersStatusRef]);

    const handleChange = (option: ISelectOption<OptionValue> | null) => {
        methods?.setValue(name, option ? option.value : null);
        handleFilters && handleFilters();
    };

    return isSelected ? (
        <div data-testid={'battlecards-filters-tracked-activity'} className={classes.selectWrapper}>
            <Controller
                render={({ field }) => (
                    <Select<ISelectOption<string>>
                        id={'battlecards-tracked-activity-driver'}
                        {...field}
                        value={options.find((option) => option.value === value)}
                        onChange={handleChange}
                        options={options}
                        isClearable={true}
                        label={FilterLabels.trackedActivity}
                    />
                )}
                name={name}
                control={methods?.control}
            />
        </div>
    ) : null;
};
